import { render } from "./UserEventsLog.vue?vue&type=template&id=195dbf8c&ts=true"
import script from "./UserEventsLog.vue?vue&type=script&lang=ts"
export * from "./UserEventsLog.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__